var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnableClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19429 7.57659C8.61874 7.96117 7.94207 8.16643 7.24985 8.16643C6.32191 8.1655 5.43223 7.79647 4.77607 7.14031C4.11991 6.48415 3.75088 5.59448 3.74995 4.66653C3.74995 3.97431 3.95522 3.29764 4.33979 2.72209C4.72436 2.14653 5.27097 1.69794 5.9105 1.43304C6.55002 1.16814 7.25374 1.09883 7.93265 1.23388C8.61156 1.36892 9.23519 1.70226 9.72466 2.19173C10.2141 2.6812 10.5475 3.30482 10.6825 3.98373C10.8176 4.66265 10.7482 5.36636 10.4833 6.00588C10.2184 6.64541 9.76985 7.19202 9.19429 7.57659ZM8.54615 2.72649C8.16244 2.47011 7.71133 2.33326 7.24985 2.33326C6.63103 2.33326 6.03756 2.57909 5.59998 3.01666C5.16241 3.45423 4.91658 4.04771 4.91658 4.66653C4.91658 5.12801 5.05343 5.57912 5.30981 5.96282C5.56619 6.34653 5.9306 6.64559 6.35695 6.82219C6.7833 6.99879 7.25244 7.04499 7.70505 6.95497C8.15766 6.86494 8.57341 6.64271 8.89972 6.3164C9.22604 5.99009 9.44826 5.57434 9.53829 5.12173C9.62832 4.66912 9.58211 4.19998 9.40551 3.77363C9.22891 3.34728 8.92985 2.98287 8.54615 2.72649ZM3.53935 10.8728C4.52356 9.8886 5.85798 9.335 7.24985 9.33346C7.4934 9.33373 7.73518 9.3509 7.97364 9.38432C7.6887 9.71371 7.45663 10.0901 7.29063 10.5003C7.27704 10.5002 7.26345 10.5001 7.24985 10.5001C6.16692 10.5001 5.12833 10.9303 4.36258 11.696C3.59683 12.4618 3.16663 13.5004 3.16663 14.5833C3.16663 14.738 3.10518 14.8864 2.99578 14.9958C2.88639 15.1052 2.73802 15.1666 2.58332 15.1666C2.42861 15.1666 2.28024 15.1052 2.17085 14.9958C2.06146 14.8864 2 14.738 2 14.5833C2.00154 13.1914 2.55515 11.857 3.53935 10.8728Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.6275L11.6251 12.3333L13 11",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 6,
    height: 6,
    rx: 3,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4001 11L10.4751 13L9.6001 12.0909",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableClient);
export default __webpack_public_path__ + "static/media/enableClient.d488512ba1cd497a1787bd9daf0cacd5.svg";
export { ForwardRef as ReactComponent };